import { SIDEBAR_WIDTH, TOPBAR_HEIGHT } from '@/styles/constant';
import styled from 'styled-components';

export const SettingLayout = styled.div`
  position: absolute;
  top: 0;
  width: calc(100vw - ${SIDEBAR_WIDTH}px);
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  background: #F8F9FA;
  padding: 1rem;
`;
